import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TenantService } from './services/tenant.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    private tenantService: TenantService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const token = sessionStorage.getItem('token');

    if (!token) {
      const slug = route.paramMap.get('slug') || '';
      const loginRoute = slug ? `/${slug}/login` : '/login';
      this.router.navigate([loginRoute]);
      return false;
    }

    return true;
  }
}
